import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import RequestPageIcon from '@mui/icons-material/RequestPage'
import { CircularProgress, Typography } from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import VouchersAPI from 'api/faber/VouchersAPI'
import { DisplayTotals, StatsCards } from 'common/AbstractStatsCards'
import { format } from 'date-fns'
import OrbitSession from 'hooks/useCookies'
import { VoucherStats } from 'types/api/faber/vouchers.type'
function mapVoucherStatsToCards(voucherStats: VoucherStats[]): DisplayTotals[] {
  return voucherStats.map((stat) => {
    /* TODO: ACCOMODATE FOR CASES WEHRE CURRENCY IS NOT SGD */
    return {
      title: `$${stat.value}`,
      data: [`Remaining:  ${stat.remaining}`, `Redeemed: ${stat.redeemed}`]
    }
  })
}

interface FaberVouchersStatsProps {
  setNumVouchers: React.Dispatch<React.SetStateAction<number | undefined>>
}

export function FaberVouchersStats(props: FaberVouchersStatsProps) {
  const { setNumVouchers } = props

  const [earliestExpiry, setEarliestExpiry] = useState<string>()
  const [voucherStatsCards, setVoucherStatsCards] = useState<DisplayTotals[]>()

  const location = useLocation()
  const faberToken = OrbitSession.get('faberToken')
  const {
    data: getVoucherStats,
    isLoading,
    refetch: refetchVoucherStats
  } = useQuery(
    ['getVoucherStats'],
    async () => {
      return VouchersAPI.getVoucherStats(faberToken)
    },
    {
      onError: () => {
        toast.error('Error getting voucher totals')
        setEarliestExpiry('Data unavailable')
        setVoucherStatsCards([{ title: 'Data unavailable', data: [''] }])
      }
    }
  )

  useEffect(() => {
    if (getVoucherStats) {
      const { data } = getVoucherStats.data
      // Ascertain that earliestExpiry is not null
      if (data.earliestExpiry) {
        setEarliestExpiry(format(new Date(data.earliestExpiry), 'dd MMM yyyy'))
      } else {
        setEarliestExpiry('Data unavailable')
      }

      // Ascertain that vouchers is not null
      if (data.vouchers) {
        setVoucherStatsCards(mapVoucherStatsToCards(data.vouchers))
      } else {
        setVoucherStatsCards([{ title: 'Data unavailable', data: [''] }])
      }
      // TODO: REPLACE THIS CALCULATION WITH DATA FROM ENDPOINT ONCE API IS UPDATED
      let voucherNum = 0
      data.vouchers.forEach((voucher) => {
        voucherNum += voucher.remaining
      })
      setNumVouchers(voucherNum)
    } else {
      // Do nothing as it is still loading
      return undefined
    }
  }, [getVoucherStats])

  useEffect(() => {
    refetchVoucherStats()
  }, [location.key])

  return !isLoading && voucherStatsCards && earliestExpiry ? (
    <>
      <Typography variant='h6'>Earliest expiry: {earliestExpiry}</Typography>
      <StatsCards
        totals={voucherStatsCards}
        headerSx={{ fontSize: 20, fontWeight: 600 }}
        bodySx={{ fontSize: 18, fontWeight: 500 }}
        icon={<RequestPageIcon color='primary' />}
      />
    </>
  ) : (
    <CircularProgress sx={{ margin: 'auto' }} />
  )
}
